import React from "react";
import ReportsDateSelect from "../../commons/ReportsDateSelect/ReportsDateSelect";

type AppProps = {
  setToggle: (data: boolean) => void;
  toggle: boolean;
  startDate: string;
  endDate: string;
  handleStartDateChange: (data: any) => void;
  handleEndDateChange: (data: any) => void;
  handleSubmitData?: () => void;
};
const CostOfGoodsHeader = ({
  setToggle,
  toggle,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
}: AppProps) => {
  return (
    <>
      <div
        className="d-flex position-relative justify-content-start align-item-center mt-3"
        style={{ gap: "0.7rem" }}
      >
        <div className="form-group">
          <label className="mb-1">Date</label>
          <div>
            <ReportsDateSelect
              type={"costOfGoods"}
              setToggle={setToggle}
              toggle={toggle}
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
            />
          </div>
        </div>
        <div className="mt-2" style={{ display: "flex", alignItems: "center" }}>
          <button
            className="btn btn-primary"
            onClick={handleSubmitData}
            disabled={
              !startDate ||
              !endDate ||
              startDate === "Invalid date" ||
              endDate === "Invalid date"
            }
          >
            Get Statement
          </button>
        </div>
      </div>
    </>
  );
};

export default CostOfGoodsHeader;
